export default __webpack_public_path__ + "static/media/skyark.d69dbf12.webp";